import React from 'react';

export default function ArrowRight() {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M18.7929 12.375h-15v-.75h15v.75z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6464 18.8535l-.7071-.7071L18.0858 12l-6.1465-6.1464.7071-.7072L19.5 12l-6.8536 6.8535z"
      />
    </svg>
  );
}
